module.exports = __webpack_public_path__ + "img/first-0-opened.700de270.webp";